@if (displayName$ | async; as displayName) {
  @if (redirectUrl$ | async; as redirectUrl) {
    <a [routerLink]="redirectUrl">
      {{ displayName }}
    </a>
  } @else {
    <div>{{ displayName }}</div>
  }
}
